import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {NavbarComponent} from './WholeCode';
const Navbar = () => {
    return (
       <NavbarComponent />
    )
}
export default Navbar;